var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogogerardo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:none;stroke:#000000;stroke-width:25;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#DC143C;stroke-width:13;stroke-miterlimit:10;}\n\t.st3{fill:#D5DDE0;}\n\t.st4{fill:#8F94AA;}\n\t.st5{fill:#DC143C;}\n\t.st6{fill:none;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fondo",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "trazos"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.83,249.57c22.94,0,24.65,25.26,24.65,25.26l-0.13,47.51c0,49.76,36.99,48.44,36.99,48.44l20.64,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.69,250.12c-11.47,0-18.23-6.82-22.12-13.64c-3.31-5.8-4.92-12.42-4.93-19.09l-0.08-39.67 c0-49.76-32.16-47.38-32.16-47.38h-17.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.83,249.57c22.94,0,23.65-24.85,23.65-24.85v-47.65c0-49.76,35.65-47.29,35.65-47.29h21.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.83,249.57l54.68,1.21l5.97,0c8.84-0.01,16-7.17,16-16v-10.69c0-6.8-5.51-12.31-12.31-12.31h-16.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 400.14,
    y1: 250.33,
    x2: 326.14,
    y2: 250.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.74,250.45c-12.75,0-21.19,7.84-24.25,14.81c-1.94,4.42-2.83,9.22-2.85,14.05l-0.12,44.85 c0,49.76-34.1,47.16-34.1,47.16l-17.27,0.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M84.83,248.44c22.94,0,23.65-24.85,23.65-24.85v-47.65c0-49.76,35.65-47.29,35.65-47.29h21.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M84.83,248.44l54.68,1.21l5.97,0c8.84-0.01,16-7.17,16-16v-10.69c0-6.8-5.51-12.31-12.31-12.31h-16.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 400.14,
    y1: 249.19,
    x2: 326.14,
    y2: 249.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M402.74,249.32c-12.75,0-21.19,7.84-24.25,14.81c-1.94,4.42-2.83,9.22-2.85,14.05l-0.12,44.85 c0,49.76-34.1,47.16-34.1,47.16l-17.27,0.04"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_280_",
    d: "M250.17,243.01h42.61c9.78,0,15.72,7.09,15.33,14.24c-0.34,6.12-3.29,15.77-10.7,23.18 c-3.11,3.11-8.21,4.82-14.36,4.82c0,0,0,0,0,0c-7.52,0-13.98-2.27-17.75-6.52c-7.11-8.01-7.49-19.65-8.45-25.49 c-0.51-3.11-2.2-5.48-6.67-5.48V243.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_271_",
    d: "M247.46,243.01h-42.61c-9.78,0-15.72,7.09-15.32,14.24c0.34,6.12,3.29,15.77,10.7,23.18 c3.11,3.11,8.21,4.82,14.36,4.82c0,0,0,0,0,0c7.52,0,13.98-2.27,17.75-6.52c7.11-8.01,7.49-19.65,8.45-25.49 c0.51-3.11,2.2-5.48,6.67-5.48V243.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_282_",
    d: "M305.5,246.78c-3.13-3.31-7.65-5.13-12.72-5.13h-43.96h-43.96c-5.08,0-9.6,1.82-12.72,5.13 c-1.29,1.36-6.66,0.49-6.66,1.72c0,6.47,2.55,6.81,2.7,8.83c0.26,3.37,1.46,3.83,1.85,3.83h49.65c4.26,0-1.04-12.04,9.14-12.04 s4.88,12.04,9.14,12.04h49.65c0.4,0,1.6-0.46,1.85-3.83c0.15-2.01,2.7-2.36,2.7-8.83C312.16,247.27,306.78,248.14,305.5,246.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_269_",
    className: "st3",
    d: "M214.57,283.72c-5.68,0-10.52-1.58-13.28-4.34c-7.42-7.42-9.94-19.24-8.49-24.44 c1.7-6.09,7.04-8.47,19.68-8.79c1.61-0.04,3.11-0.06,4.52-0.06c13.09,0,19.1,1.76,20.1,12.22c0.68,7.13-1.42,14.05-5.89,19.47 C228.28,281.34,221.6,283.72,214.57,283.72C214.58,283.72,214.58,283.72,214.57,283.72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_278_",
    className: "st3",
    d: "M283.05,283.72c5.68,0,10.52-1.58,13.28-4.34c7.42-7.42,9.94-19.24,8.49-24.44 c-1.7-6.09-7.04-8.47-19.68-8.79c-1.61-0.04-3.11-0.06-4.52-0.06c-13.09,0-19.1,1.76-20.1,12.22c-0.68,7.13,1.42,14.05,5.89,19.47 C269.35,281.34,276.03,283.72,283.05,283.72C283.05,283.72,283.05,283.72,283.05,283.72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_276_",
    className: "st4",
    d: "M262.02,265.22c14.96-0.56,29.01-2.03,41.78-4.39c0.27-2.25,0.21-4.21-0.16-5.56 c-1.29-4.61-4.84-7.53-18.51-7.88c-1.6-0.04-3.09-0.06-4.49-0.06c-13.98,0-18.03,2.39-18.86,11.1 C261.54,260.67,261.63,262.96,262.02,265.22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_270_",
    className: "st4",
    d: "M235.61,265.22c-14.96-0.56-29.01-2.03-41.78-4.39c-0.27-2.25-0.21-4.21,0.16-5.56 c1.29-4.61,4.84-7.53,18.51-7.88c1.6-0.04,3.09-0.06,4.49-0.06c13.98,0,18.03,2.39,18.86,11.1 C236.09,260.67,236,262.96,235.61,265.22z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_267_",
    x: 186.77,
    y: 249.97,
    className: "st5",
    width: 4.63,
    height: 1.86
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_275_",
    x: 306.23,
    y: 249.97,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 617.0903 501.7979)",
    className: "st5",
    width: 4.63,
    height: 1.86
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M181.93,202.73c0,0-2.58-26.88,8.19-47"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 249.43,
    y1: 177.22,
    x2: 249.43,
    y2: 134.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M240.43,177.22c0,0-1.41-26.16,1.76-37.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M192.01,195.61c0,0,2.54-28.24,10.65-48.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M202.66,195.61c0,0,4.72-38.82,12.77-48.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215.68,183.71c0,0,3.93-27.35,12.4-44.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M230.9,177.22c0,0,0-21.07,4.24-36.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M316.86,201.77c0,0,2.58-26.88-8.19-47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M258.36,176.27c0,0,1.41-26.16-1.76-37.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M306.78,194.65c0,0-2.54-28.24-10.65-48.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M296.12,192.65c0,0-4.72-38.82-12.77-48.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M283.11,182.76c0,0-3.93-27.35-12.4-44.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M267.89,176.27c0,0,0-21.07-4.24-36.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M249.11,360.51c-7.85,0-15.74-1.13-23.43-3.25c-7.65-2.21-15.18-5.36-21.96-9.85 c-1.72-1.08-3.34-2.31-4.98-3.52l-2.37-1.93c-0.79-0.65-1.53-1.36-2.29-2.03c-0.77-0.67-1.48-1.41-2.22-2.13 c-0.74-0.71-1.44-1.46-2.12-2.23c-0.7-0.75-1.38-1.52-2.02-2.32l-0.99-1.19l-0.98-1.28c-2.55-3.47-4.49-7.38-5.81-11.48 c-1.31-4.1-1.93-8.45-1.93-12.7c-0.01-15.6,0.27-31.2,0.85-46.8c0.63-15.6,1.47-31.2,3.15-46.8c1.68,15.6,2.51,31.2,3.15,46.8 c0.59,15.6,0.86,31.2,0.85,46.8c-0.06,7.05,2,14,5.93,19.81l0.75,1.08l0.84,1.1c0.55,0.74,1.13,1.46,1.73,2.16 c0.59,0.71,1.19,1.42,1.82,2.1c0.62,0.68,1.23,1.39,1.9,2.04c2.58,2.67,5.39,5.14,8.36,7.41c5.93,4.58,12.58,8.32,19.63,11.28 C234,356.62,241.47,358.75,249.11,360.51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M248.89,360.51c7.65-1.76,15.12-3.89,22.15-6.94c1.75-0.78,3.52-1.48,5.21-2.37 c0.85-0.43,1.71-0.83,2.55-1.28l2.48-1.4l1.23-0.7l1.2-0.76l2.39-1.5c1.54-1.09,3.11-2.12,4.57-3.29 c2.99-2.26,5.78-4.74,8.36-7.41c2.56-2.65,5.01-5.55,7.05-8.47c3.93-5.78,5.98-12.75,5.92-19.8c-0.01-15.6,0.27-31.2,0.85-46.81 c0.63-15.6,1.47-31.2,3.15-46.81c1.68,15.6,2.51,31.2,3.15,46.81c0.59,15.6,0.86,31.2,0.85,46.81c0,4.25-0.63,8.59-1.93,12.69 c-1.32,4.1-3.26,8.02-5.82,11.49c-2.57,3.37-5.29,6.35-8.32,9.13c-1.49,1.4-3.08,2.69-4.66,3.97c-1.65,1.2-3.27,2.44-4.99,3.52 c-6.78,4.5-14.31,7.63-21.96,9.85C264.63,359.38,256.74,360.5,248.89,360.51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M137.12,125.12c-4.05,1.82-7.73,4.13-11.08,6.81c-1.66,1.35-3.26,2.77-4.74,4.31 c-0.71,0.8-1.45,1.55-2.17,2.34l-1.95,2.52c-0.35,0.4-0.64,0.84-0.93,1.3l-0.87,1.34l-0.89,1.33c-0.28,0.45-0.5,0.94-0.77,1.4 l-1.54,2.81c-0.41,0.99-0.84,1.97-1.29,2.95l-0.66,1.48l-0.52,1.53l-1.09,3.07c-0.68,2.07-1.14,4.21-1.86,6.34 c0.01-1.11,0.07-2.21,0.13-3.33c0.02-0.56,0.07-1.11,0.11-1.67c0.04-0.56,0.06-1.12,0.18-1.67l0.64-3.3 c0.11-0.55,0.22-1.1,0.35-1.65l0.52-1.61c0.34-1.07,0.7-2.15,1.08-3.21l1.44-3.08c0.25-0.51,0.48-1.03,0.76-1.53l0.9-1.45 l0.92-1.44c0.3-0.49,0.61-0.96,0.98-1.4c2.69-3.68,6.11-6.81,9.9-9.28C128.46,127.58,132.7,125.75,137.12,125.12z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M137.12,253.24c3.6-0.04,7.08-0.52,10.33-1.51c3.23-1.02,6.18-2.66,8.49-4.97c2.35-2.29,4.05-5.21,5.28-8.4 c1.24-3.19,2.01-6.63,2.72-10.17c0.53,3.57,0.42,7.27-0.49,10.88c-0.86,3.6-2.65,7.13-5.41,9.83c-2.73,2.73-6.36,4.47-10.04,5.1 C144.32,254.63,140.54,254.42,137.12,253.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M396.53,251.46c-2.66,1.48-5,3.25-7.08,5.23c-2.06,2-3.85,4.2-5.34,6.62c-0.36,0.61-0.68,1.24-1.03,1.86 c-0.38,0.6-0.65,1.27-0.93,1.92c-0.28,0.66-0.62,1.29-0.86,1.97c-0.23,0.68-0.48,1.36-0.74,2.04c-0.12,0.34-0.28,0.68-0.36,1.03 c-0.09,0.35-0.18,0.71-0.29,1.06l-0.63,2.12c-0.37,1.44-0.64,2.9-1.1,4.38c-0.21-1.5-0.33-3.04-0.36-4.58l0.16-2.3 c0.05-0.77,0.13-1.54,0.31-2.3c0.15-0.76,0.31-1.52,0.49-2.28c0.17-0.76,0.5-1.48,0.75-2.23c0.48-1.5,1.29-2.87,2.03-4.26 c1.66-2.69,3.85-5.07,6.42-6.87C390.53,253.08,393.46,251.77,396.53,251.46z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M358.76,396.18"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M344.29,370.14c1.86,0.27,3.68,0.2,5.43-0.16c0.88-0.1,1.73-0.43,2.57-0.64c0.82-0.35,1.66-0.59,2.44-0.99 c3.15-1.54,6.01-3.64,8.48-6.21c0.32-0.31,0.66-0.59,0.96-0.93l0.88-1.01l1.79-2.01c1.07-1.45,2.24-2.84,3.3-4.32 c0.52-0.75,1.02-1.51,1.56-2.26c0.52-0.75,1.11-1.47,1.57-2.27c1-1.55,2-3.11,3.13-4.63c-0.52,1.8-1.18,3.55-1.83,5.32 c-0.7,1.74-1.59,3.4-2.45,5.09c-0.4,0.86-0.96,1.63-1.46,2.43l-1.57,2.38c-0.59,0.75-1.21,1.48-1.82,2.22l-0.93,1.1 c-0.32,0.36-0.68,0.68-1.03,1.02c-2.67,2.75-6.02,5-9.74,6.25c-0.45,0.19-0.94,0.27-1.41,0.4c-0.48,0.11-0.95,0.24-1.43,0.32 c-0.98,0.07-1.94,0.26-2.92,0.19C347.91,371.4,345.96,371.05,344.29,370.14z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogogerardo);
export default __webpack_public_path__ + "static/media/logogerardo.56a55cb6f506a5d49a3d4ed20d714d55.svg";
export { ForwardRef as ReactComponent };